<template>
    <v-container fluid>
        <v-row>
            <v-col >
                <h4 class="text-h4">{{$t("stock_transfer_voucher")}}</h4>
                <p class="text-subtitle-1">{{$t("transfer_stock_items_between_warehouses")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(perm.stock_transfer.create)">
                <v-btn color="primary" block @click="handleNew">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("new_voucher")}}
                </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('search')"
                    rounded
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    @input="handleInputSearch"
                    clearable
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    disable-sort
                    :page.sync="page"
                    :options.sync="options"
                    :loading="loading"
                    :server-items-length="serverItemsLength"
                    >
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleDisplay(item)" v-if="hasPermission(perm.stock_transfer.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.date`]="{item}">
                        {{formatDate(item.date)}}
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permission from "./../../../data/permissions"
import stockTransferAPI from '../../../services/stockJournal/stockTransfer';
import PStatus from './../../../components/common/PStatus.vue';
import moment from 'moment';
import getColor from './../../../utils/getColor';
import authorize from '../../../utils/authorize';

export default {
    components: {
        PStatus
    },
    data() {
        return {
            data: [],
            options: {},
            search: {},
            page: 1,
            serverItemsLength: 0,
            loading: false,
            warehouseId: null,
            tab: 0,
            perm: permission
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("code"), value: "code" },
                { text: this.$t("date"), value: "date" },
                { text: this.$t("target_warehouse"), value: "target_warehouse" },
                { text: this.$t("created_by"), value: "created_by" },
                { text: this.$t("state"), value: "state" }
            ];
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        },
        tab: {
            handler(value) {
                this.options = {...this.options, state_code: this.states[value].code}
            }
        }
    },
    methods: {
        getColor,
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        handleNew() {
            this.$router.push({
                name: "TransferIssueVoucherCreate"
            })
        },
        fetch() {
            this.loading = true;
            this.data = [];
            stockTransferAPI.index({...this.options, source_warehouse_id: this.warehouseId}).then(response => {
                this.data = response.data.data;
                this.serverItemsLength = response.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDisplay(item) {
            this.$router.push({
                name: "TransferIssueVoucherDisplay",
                params: {
                    id: item.id
                }
            })
        },
        handleInputSearch(value) {
            this.options = {...this.options, code: value }
        },
        hasPermission(code) {
            return authorize(code)
        }
    },
    created() {
        this.warehouseId = this.$route.params.warehouseId;
    }
}
</script>

<style>

</style>